enum ChallengeKind {
  sms = 'sms',
  biometric = 'biometric',
  email = 'email',
  smsLink = 'sms_link',
}

export default ChallengeKind;
